import { Component, AfterViewInit, OnInit, OnDestroy, HostListener } from '@angular/core';
import { AuthService } from './auth.service';
import { AppCommonService } from './appcommon.service';
import { GrowlModule } from 'primeng/primeng';
import { LoaderService } from './LoaderService';
import { Router } from '@angular/router';
import { Meta } from '@angular/platform-browser';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { TokenModel, ILoggedUser } from './headerandnavigation/loggeduser/loggeduser';
import { HeaderAndNavigationService } from './headerandnavigation/headerandnavigation.service';
declare var $: any;
@Component({
  selector: 'mft-root',
  templateUrl: './app.component.html'
})
export class AppComponent implements OnInit, AfterViewInit, OnDestroy {
  public pageTitle: string = 'Home';
  showLoader: boolean;
  public className = "";
  loggedUser: ILoggedUser;
  constructor(public authService: AuthService,
    public appCommonService: AppCommonService,
    public headerAndNavigationService: HeaderAndNavigationService,
    private loaderService: LoaderService,
    private router: Router,
    private meta: Meta,
    public oidcSecurityService: OidcSecurityService
  ) {
    this.appCommonService.pageName = this.pageTitle;
    this.meta.updateTag({ name: 'title', content: this.appCommonService.pageName });

    if (this.oidcSecurityService.moduleSetup) {
      this.doCallbackLogicIfRequired();
    } else {
      this.oidcSecurityService.onModuleSetup.subscribe(() => {
        this.doCallbackLogicIfRequired();
      });
    }
  }

  ngOnInit() {
    this.loggedUser = this.headerAndNavigationService.getLoggedUser();
    //debugger
    //this.loggedUser = this.headerAndNavigationService.getLoggedUser();
    //if (this.loggedUser == null) {
    //  this.router.navigate([window.location.pathname]);
    //}
  }

  ngAfterViewInit() {
    this.loaderService.status.subscribe((val: boolean) => {
      this.showLoader = val;
      this.authService.showLoader = val;
    });

    //$.cookieCuttr({
    //  cookieAnalytics: false,
    //  cookieMessage: 'This site uses cookies: <a target="_blank" href="https://www.fuelcardservices.com/privacy-policy/">Find out more</a>.',
    //  //cookiePolicyLink: '',
    //  cookieAcceptButtonText: 'Okay, thank you'
    //});
    // this.className = this.authService.className;
  }

  ngOnDestroy(): void {
    this.oidcSecurityService.onModuleSetup.unsubscribe();
  }

  private doCallbackLogicIfRequired() {
    if (window.location.hash) {
      this.oidcSecurityService.authorizedCallback();
    }
  }

  Logout() {
    this.headerAndNavigationService.ClearUserData();
    this.authService.logout();

  }

  @HostListener('window:silentRefresh', ['$event.detail'])
  silentRefresh(detail) {
    //let tdetail = detail;
    //let details = tdetail.split("&");
    //let atoken = details[1];
    //let atokens = atoken.split("=");
    //let token = atokens[1];      
    let tokenModel: TokenModel = new TokenModel();
    tokenModel.access_token = this.authService.getUserToken()
    tokenModel.token_type = "bearer";
    tokenModel.expires_in = 3600;
    this.authService.saveToken(tokenModel);
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts